import React from 'react';
import Dropdown, { DropdownButton, DropdownMenu } from '../base/Dropdown';

class Toolbar extends React.Component {

  render() {
    return (
      <header className="toolbar navbar-light navbar">
        <a href="" className="navbar-brand">Base kit</a>
        <ul className="nav navbar-nav navbar-right hidden-md-up">
        <Dropdown ref="fullDropdown" component="li" className="full-dropdown" hasTransition={true} open>
            <DropdownButton
              component="a"
              className="nav-link dropdown-button"
              href=""
            >
              <i className="fa fa-bars"></i>
            </DropdownButton>
            <DropdownMenu>
              <button
                className="btn btn-text-muted dropdown-full-close"
                onClick={() => this.refs.fullDropdown.close()}
              >
                <i className="fa fa-remove"></i>
              </button>
              <div className="dropdown-header">
                <h4 className="dropdown-title">Teste</h4>
              </div>
              <div className="dropdown-item">
                <div className="row sp-xs-bottom-1">
                  <div className="col-sm-6 sp-xs-bottom-1 sp-sm-bottom-none">
                    <a href="" className="text-accent">Pricing</a>
                  </div>
                  <div className="col-sm-6">
                    <a href="" className="text-accent">About Stripe</a>
                  </div>
                </div>
                <div className="row sp-xs-bottom-1">
                  <div className="col-sm-6 sp-xs-bottom-1 sp-sm-bottom-none">
                    <a href="" className="text-accent">Customers</a>
                  </div>
                  <div className="col-sm-6">
                    <a href="" className="text-accent">Jobs</a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 sp-xs-bottom-1 sp-sm-bottom-none">
                    <a href="" className="text-accent">Documentation</a>
                  </div>
                  <div className="col-sm-6">
                    <a href="" className="text-accent">Blog</a>
                  </div>
                </div>
              </div>
              <a href="#" onClick={() => this.refs.modal.toggle() } className="dropdown-footer sp-xs-top-1 text-accent text-weight-semibold">
                Create Account <i className="fa fa-arrow-right"></i>
              </a>
            </DropdownMenu>
          </Dropdown>
        </ul>
        <ul className="nav navbar-nav hidden-sm-down">
          <li><a className="nav-link active" href="">Features</a></li>
          <li><a className="nav-link" href="">Pricing</a></li>
          <Dropdown component="li" className="dropdown-animation" hasTransition={true}>
            <DropdownButton
              component="a"
              className="nav-link dropdown-button"
              href=""
            >
              More <i className="fa fa-angle-down" />
            </DropdownButton>
            <DropdownMenu>
              <a href="" className="dropdown-link">Create Page</a>
              <a href="" className="dropdown-link">Manage Pages</a>
              <div className="dropdown-separator" />
              <a href="" className="dropdown-link">Create Group</a>
              <a href="" className="dropdown-link">New groups</a>
              <div className="dropdown-separator" />
              <a href="" className="dropdown-link">Create ads</a>
              <a href="" className="dropdown-link">Advertising on Starter Kit</a>
              <div className="dropdown-separator" />
              <a href="" className="dropdown-link">Blog</a>
              <a href="" className="dropdown-link">About</a>
              <a href="" className="dropdown-link">Jobs</a>
            </DropdownMenu>
          </Dropdown>
        </ul>
        <ul className="nav navbar-nav navbar-right hidden-sm-down">
          <li><a className="nav-link" href="">Documentation</a></li>
          <li><a className="nav-link" href="">Support</a></li>
        </ul>
      </header>
    );
  }
}

Toolbar.displayName = 'Toolbar';

export default Toolbar;



/** WEBPACK FOOTER **
 ** ./src/components/elements/Toolbar.js
 **/